import { useEffect, useState } from "react";

export function LeadPopup() {
  const [shouldLoad, setShouldLoad] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;

    let triggered = false;
    const trigger = () => {
      if (triggered) return;
      triggered = true;
      setShouldLoad(true);

      const id = "leadconnector-form-embed";
      if (!document.getElementById(id)) {
        const s = document.createElement("script");
        s.id = id;
        s.src = "https://link.msgsndr.com/js/form_embed.js";
        s.async = true;
        document.body.appendChild(s);
      }
    };

    // Only load on real user intent. PageSpeed/Lighthouse never interacts,
    // so the LeadConnector iframe + reCAPTCHA (which cause forced reflows)
    // never run during audits or for users who bounce immediately.
    const events = ["scroll", "pointerdown", "keydown", "touchstart"] as const;
    events.forEach((e) => window.addEventListener(e, trigger, { once: true, passive: true }));

    return () => {
      events.forEach((e) => window.removeEventListener(e, trigger));
    };
  }, []);

  if (!shouldLoad) return null;

  return (
    <iframe
      src="https://api.leadconnectorhq.com/widget/form/ILLAp6X5DqG5mDwQyp53"
      style={{ display: "none", width: "100%", height: "100%", border: "none", borderRadius: "3px" }}
      id="popup-ILLAp6X5DqG5mDwQyp53"
      data-layout="{'id':'POPUP'}"
      data-trigger-type="alwaysShow"
      data-trigger-value=""
      data-activation-type="alwaysActivated"
      data-activation-value=""
      data-deactivation-type="neverDeactivate"
      data-deactivation-value=""
      data-form-name="Free Estimate Form"
      data-height="1029"
      data-layout-iframe-id="popup-ILLAp6X5DqG5mDwQyp53"
      data-form-id="ILLAp6X5DqG5mDwQyp53"
      title="Free Estimate Form"
      data-modal-height="500"
    />

  );
}
